import { FC } from "react";
import { Box, TableCell, TableRow, TextField, InputAdornment, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { StorageRow } from "./Types";
import TableDesign, { TableHeading } from "../../../../../components/common/table/TableDesign";
import CustomButton from "../../../../../components/common/button/CustomButton";

const tableHeadings: TableHeading[] = [
  { label: "Storage Name", align: "left" },
  { label: "Storage Type", align: "left" },
  { label: "Units", align: "left" },
  { label: "Action", align: "left" },
];

interface SelectStorageStepProps {
  storages: StorageRow[];
  search: string;
  onSearchChange: (value: string) => void;
  onSelectStorage: (storageId: string) => void;
}

const SelectStorageStep: FC<SelectStorageStepProps> = ({
  storages,
  search,
  onSearchChange,
  onSelectStorage,
}) => (
  <Box>
    <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
      <TextField
        size="small"
        placeholder="Search by Storage name, Type"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ fontSize: 18, color: "#999" }} />
            </InputAdornment>
          ),
        }}
        sx={{
          width: 300,
          "& .MuiInputBase-root": { height: "30px" },
          "& .MuiInputBase-input": { padding: "5px 8px" },
        }}
      />
    </Box>
    <TableDesign
      tableHeadings={tableHeadings}
      tableHeadColor="#02906f"
      cellColor="#fff"
      filterOption={null}
      setFilterOption={() => {}}
      stickyHeader
    >
      {storages.length > 0 ? (
        storages.map((storage:any) => (
          <TableRow
            key={storage.id}
            hover
            onClick={() => onSelectStorage(storage.id)}
            sx={{ cursor: "pointer" }}
          >
            <TableCell>{storage.site_name}</TableCell>
            <TableCell>{storage.site_type}</TableCell>
            <TableCell>
              <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
                {storage.number_of_units === 0 ? "Complete" : `${storage.number_of_units} Available`}
              </Typography>
              <Typography sx={{ fontSize: "12px", color: "#777" }}>
                ({storage.totalUnits - storage.availableUnits} / {storage.totalUnits})
              </Typography>
            </TableCell>
            <TableCell>
              <CustomButton
                title="Select"
                onClick={(event) => {
                  event.stopPropagation();
                  onSelectStorage(storage.id);
                }}
              />
            </TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={tableHeadings.length} align="center">
            No storage found.
          </TableCell>
        </TableRow>
      )}
    </TableDesign>
  </Box>
);

export default SelectStorageStep;